// No imports needed for relative paths

export interface CareerButton {
    id: string;
    text: string;
    href: string;
    primary: boolean;
}

export interface CareerHeroData {
    title: string;
    titleHighlight: string;
    subtitle: string;
    ctaButtons: CareerButton[];
    images: string[];
}

export interface SquadMember {
    name: string;
    role: string;
    image: string;
}

export interface BerrySquadData {
    title: string;
    subtitle: string;
    members: SquadMember[];
}

export interface OpenPosition {
    id: string;
    title: string;
    location: string;
    type: string;
    category: string;
    link: string;
}

export interface OpenPositionsData {
    title: string;
    subtitle: string;
    positions: OpenPosition[];
}

export const careersHeroData: CareerHeroData = {
    title: 'Build the future of',
    titleHighlight: 'digital health',
    subtitle: 'Join a team of obsessive artists building the best-in-class software for orthodontics',
    ctaButtons: [
        { id: 'start', text: 'See Job Openings', href: 'https://www.linkedin.com/company/berrystudio-us/jobs/', primary: true },
        { id: 'features', text: 'All Products', href: '/products', primary: false },
    ],
    images: [
        'website/group-photo-kahdg.png',
        'website/group-photo-two-ajhfhfd.png',
        'website/group-photo-three-bhagfd.png',
    ]
}

export const berrySquadData: BerrySquadData = {
    title: 'Meet our Berry Squad',
    subtitle: 'We are artists and coders adding a smile to smile makers.',
    members: [
        {
            name: 'Karthik',
            role: 'CEO',
            image: 'website/teams/karthik-sgahj.webp'
        },
        {
            name: 'Dr. Nourah',
            role: 'Clinical',
            image: 'website/teams/nourah-ahdv.webp'
        },
        {
            name: 'Dr. Rooz',
            role: 'Clinical',
            image: 'website/teams/rooz-agdjh.webp'
        },
        {
            name: 'Katie',
            role: 'Product',
            image: 'website/teams/katie-kahdh.webp'
        },
        {
            name: 'Abhishek',
            role: 'Operations',
            image: 'website/teams/abhishek-kdgag.webp'
        },
        {
            name: 'Arivoli',
            role: 'Design',
            image: 'website/teams/arivoli-asvdha.webp'
        },
        {
            name: 'Aswathy',
            role: 'Operations',
            image: 'website/teams/aswathy-ashhgd.webp'
        },
        {
            name: 'Chithra',
            role: 'Operations',
            image: 'website/teams/chithra-asasd.webp'
        },
        {
            name: 'Deepan',
            role: 'Tech',
            image: 'website/teams/deepan-asghdv.webp'
        },
        {
            name: 'Devika',
            role: 'Operations',
            image: 'website/teams/devika-ashgd.webp'
        },
        {
            name: 'Dhamodharan',
            role: 'Tech',
            image: 'website/teams/dhamodharan-ahsdbf.webp'
        },
        {
            name: 'Dharani',
            role: 'Operations',
            image: 'website/teams/dharani-ahgdgd.webp'
        },
        {
            name: 'Divakar',
            role: 'Operations',
            image: 'website/teams/divakar-shgsag.webp'
        },
        {
            name: 'Divya',
            role: 'Customer Success',
            image: 'website/teams/divya-ahgdg.webp'
        },
        {
            name: 'Fahad',
            role: 'Design',
            image: 'website/teams/fahad-ahdguj.webp'
        },
        {
            name: 'Fenolin',
            role: 'Tech',
            image: 'website/teams/fenolin-ahdhf.webp'
        },
        {
            name: 'Gowtham',
            role: 'Design',
            image: 'website/teams/gowtham-adhfbn.webp'
        },
        {
            name: 'Ilan',
            role: 'Product',
            image: 'website/teams/Ilan-ajhgfm.webp'
        },
        {
            name: 'Jaden',
            role: 'Customer Success',
            image: 'website/teams/jaden-ahdhf.webp'
        },
        {
            name: 'Keerthika',
            role: 'Operations',
            image: 'website/teams/keethika-hahkfa.webp'
        },
        {
            name: 'Mahesh',
            role: 'Tech',
            image: 'website/teams/mahesh-ahdhfj.webp'
        },
        {
            name: 'Meena',
            role: 'Operations',
            image: 'website/teams/meena-fhjfgl.webp'
        },
        {
            name: 'Nagadeepthi',
            role: 'Operations',
            image: 'website/teams/nagadeepthi-asjhdg.webp'
        },
        {
            name: 'Navasakthi Balan',
            role: 'Tech',
            image: 'website/teams/navasakthi-dfhfja.webp'
        },
        {
            name: 'Neina',
            role: 'Operations',
            image: 'website/teams/neina-ahfng.webp'
        },
        {
            name: 'Pavithran',
            role: 'Tech',
            image: 'website/teams/pavithran-dhgja.webp'
        },
        {
            name: 'Prabhu',
            role: 'Design',
            image: 'website/teams/prabhu-bfgbf.webp'
        },
        {
            name: 'Praveen Gangadhar',
            role: 'Tech',
            image: 'website/teams/praveen-bjasgf.webp'
        },
        {
            name: 'Pravin Ayyavu',
            role: 'Tech',
            image: 'website/teams/pravin-ashasdjh.webp'
        },
        {
            name: 'Raghu',
            role: 'Tech',
            image: 'website/teams/raghu-ahdkfg.webp'
        },
        {
            name: 'Santhosh',
            role: 'Tech',
            image: 'website/teams/santhosh-lfhgag.webp'
        },
        {
            name: 'Sathya',
            role: 'Tech',
            image: 'website/teams/sathya-fhakd.webp'
        },
        {
            name: 'Sri Balaji',
            role: 'Tech',
            image: 'website/teams/balaji-ahfkg.webp'
        },
        {
            name: 'Tejaswi',
            role: 'Product',
            image: 'website/teams/tejaswi-gjghsj.webp'
        }
    ]
}

export const openPositionsData: OpenPositionsData = {
    title: 'Open Positions',
    subtitle: 'Join a diverse group of designers, engineers, and problem solvers passionate about transforming healthcare.',
    positions: [
        {
            id: '1',
            title: 'Customer Success',
            location: 'San Francisco',
            type: 'Remote',
            category: 'Sales',
            link: '#'
        },
        {
            id: '2',
            title: 'Manager/Senior Frontend Engineer',
            location: 'India',
            type: 'Onsite',
            category: 'Product',
            link: '#'
        }
    ]
}
